package com.merkost.handpass.api.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AdminConversationSummary(
    val id: String,
    @SerialName("listing_id") val listingId: String? = null,
    @SerialName("listing_title") val listingTitle: String? = null,
    @SerialName("buyer_id") val buyerId: String? = null,
    @SerialName("buyer_name") val buyerName: String? = null,
    @SerialName("seller_id") val sellerId: String? = null,
    @SerialName("seller_name") val sellerName: String? = null,
    @SerialName("last_message_at") val lastMessageAt: String? = null,
    @SerialName("last_message_preview") val lastMessagePreview: String? = null,
    @SerialName("message_count") val messageCount: Int = 0,
)

@Serializable
data class AdminConversationsResponse(
    val conversations: List<AdminConversationSummary>,
)
